export default __webpack_public_path__ + "static/ResizingAD-ee864f37136088d2db5efbf2632bd009.mp4";